// extracted by mini-css-extract-plugin
module.exports = {"input-preview__label":"input-preview_input-preview__label__Rw4MA","input-preview__value":"input-preview_input-preview__value__n6qi3"};